import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  consumeInviteCodeFromClipboard,
  getStoredInviteCode,
  setStoredInviteCode,
} from "@/utils/invite-code";
import { STORAGE_KEYS } from "@/lib/api/config";
import { isIOSApp } from "@/platform";

interface InviteHandoffOptions {
  search: string;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export function useInviteHandoff({ search, isLoading, isAuthenticated }: InviteHandoffOptions) {
  useEffect(() => {
    if (!search) return;

    const params = new URLSearchParams(search);
    const invite = params.get("invite");
    if (invite) {
      setStoredInviteCode(invite);
    }
  }, [search]);

  useEffect(() => {
    if (!isIOSApp()) return;
    if (isLoading) return;
    if (isAuthenticated) return;
    if (localStorage.getItem(STORAGE_KEYS.INVITE_INSTALL_CHECKED) === "1") return;

    const timer = window.setTimeout(async () => {
      if (getStoredInviteCode()) {
        localStorage.setItem(STORAGE_KEYS.INVITE_INSTALL_CHECKED, "1");
        return;
      }

      try {
        await consumeInviteCodeFromClipboard();
      } catch (error) {
        Sentry.captureException(error, { tags: { errorSource: "invite-clipboard-install-check" } });
      } finally {
        localStorage.setItem(STORAGE_KEYS.INVITE_INSTALL_CHECKED, "1");
      }
    }, 500);

    return () => window.clearTimeout(timer);
  }, [isLoading, isAuthenticated]);
}
